module.exports = __webpack_public_path__ + "img/graphs.d676a8f5.svg";